import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { IData } from '../types';

//https://marmelab.com/react-admin/List.html#exporter
//https://www.npmjs.com/package/jsonexport#typehandlers
const exporter = (records: IData[], fields: string[], filename = 'Export'): void => {
    const data = records.map((obj: IData) => {
        return Object
            .fromEntries(
                Object
                    .entries(obj)
                    .filter(([key]) => fields.some(f => f.toLowerCase() === key.toLowerCase()))
            );
    });

    jsonExport(data, {
        rename: fields
    }, (err: Error | null, csv: string) => {
        if (err) {
            console.error('Failed to export CSV:', err);
            return;
        }
        downloadCSV(csv, filename); // download as 'csv` file
    });
};

export default exporter;
